export function purchasePrintPdf( detail, htmlFc ){ 
  let elem        = document.querySelector("#purchase-fullcont");
  let dbid        = elem.getAttribute("data-dbid");

  if (detail.id != "" && detail.id != "purchase-fullcont") {
    printPdf({ id: detail.id, type: "print", entity: detail.entity, report: detail.report });
  }else{
    printPdf({ id: dbid, type: "print", entity: detail.entity, report: detail.report });
  }
}

function printPdf(data) {
  const formData = new FormData();
  formData.append('id', data.id);
  formData.append('type', data.type);
  formData.append('entity', data.entity);
  formData.append('reportName', data.report);
  const isPdf = true;

  const controller = new AbortController();
  const timeout    = setTimeout(() => { controller.abort() }, 30000);

  let options = {
    method: 'POST',
    body: formData,
    signal: controller.signal,
    credentials: 'same-origin'
  };

  // fetch(`./server/php/queries/report/purchase/pdf-invoice.php`, options)
  fetch(`./server/php/report/report-pdf.php`, options)
  // .then(async (response) => {
  //     // 1. Leemos la respuesta como TEXTO puro para ver qué escupió PHP
  //     const textResponse = await response.text();

  //     // 2. Lo imprimimos en la consola
  //     console.log("=== RESPUESTA DE PHP ===");
  //     console.log(textResponse);

  //     // Detenemos el proceso aquí intencionalmente para que puedas leer la consola
  //     throw new Error("Detenido intencionalmente para depurar PHP");
  //   })

    // .then(response => {
    //   if (!response.ok) {
    //     alert("An error occurred while printing the PDF. Please try again.");
    //   } else {
    //     return response.text(); // Devolver el nombre del archivo PDF generado
    //   }
    // })
    // .then(pdfFileName => {
    //   if (pdfFileName) {
    //     const iframe = document.querySelector("#reportIframe");
    //     iframe.src = pdfFileName;

    //     setTimeout(() => {
    //       iframe.contentWindow.print();
    //     }, 200);

    //     // // Ruta base del servidor
    //     // const baseUrl = 'https://beestock.gosive.com/server/server/';

    //     // // Agregar la parte faltante a la ruta del PDF
    //     // const fullPath = pdfFileName.startsWith('server/') ? pdfFileName : 'server/' + pdfFileName;

    //     // // Construir la URL absoluta del archivo PDF
    //     // const realPdfUrl = new URL(fullPath, baseUrl).href;

    //     // // Crear un iframe para cargar el PDF generado
    //     // const iframe         = document.createElement("iframe");
    //     // iframe.style.display = "none";
    //     // iframe.src           = realPdfUrl;
    //     // document.body.appendChild(iframe);
        
    //     // // Esperar a que el PDF se cargue en el iframe antes de imprimir
    //     // iframe.contentWindow.print();

    //     // console.log(realPdfUrl)

    //   }
    // })

    .then((response) => {
      if (!response.ok) throw new Error("report-pdf");
      // 1. Cambiamos .text() por .blob() para manejar el binario del PDF correctamente

      return response.blob();
    })
    .then((blob) => {
      if (isPdf) {
        // --- LÓGICA PARA PDF ---
        const pdfBlob = new Blob([blob], { type: "application/pdf" });
        const fileUrl = URL.createObjectURL(pdfBlob);
        const newTab = window.open(fileUrl, "_blank");

        if (newTab) {
          newTab.addEventListener('load', () => {
            URL.revokeObjectURL(fileUrl);
          }, { once: true });
        }
      } else {
        // --- LÓGICA PARA CSV ---
        // Se define el MIME type para CSV
        const csvBlob = new Blob([blob], { type: "text/csv;charset=utf-8;" });
        const fileUrl = URL.createObjectURL(csvBlob);

        // Creamos un enlace temporal en el DOM
        const tempLink = document.createElement("a");
        tempLink.href = fileUrl;

        // Asignamos un nombre de archivo por defecto (puedes personalizarlo)
        tempLink.setAttribute("download", `report_${new Date().getTime()}.csv`);
        tempLink.style.display = "none";

        document.body.appendChild(tempLink);
        tempLink.click(); // Disparamos la descarga

        // Limpiamos el DOM y liberamos la memoria
        document.body.removeChild(tempLink);
        URL.revokeObjectURL(fileUrl);
      }
    })
    .catch(error => {
      console.log('An error occurred while printing the PDF:', error);
      throw error;
    });
}